import { CSSProperties, PropsWithChildren } from 'react';

interface Props {
  readonly className: string;
  readonly left: number | string;
  readonly height: number;
  readonly offsetX: number;
  readonly offsetY: number;
  readonly position?: 'top' | 'center' | 'bottom';
  readonly noEvents?: boolean;
  readonly fullHeight?: boolean;
  readonly zIndex?: number;
  readonly anchor?: 'left' | 'right';
  readonly innerRef: any;
  readonly style?: CSSProperties;
  readonly overflowOffset?: number;
}

export function StreamElWrapper(p: PropsWithChildren<Props>) {
  const style: any = {
    left: p.left,
    position: 'absolute',
    textAlign: 'center',
    background: 'transparent',
    whiteSpace: 'nowrap',
  };

  if (p.noEvents) {
    style.pointerEvents = 'none';
  }

  if (p.fullHeight) {
    style.height = p.height;
  }

  if (p.zIndex) {
    style.zIndex = p.zIndex;
  }

  if (p.position === 'top') {
    style.top = 0;
  }

  if (p.position === 'bottom') {
    style.bottom = 0;
  }

  if (p.position === 'center') {
    style.top = '50%';
  }

  let tX: string | number = 0;
  let tY: string | number = 0;

  if (p.anchor === 'right') {
    tX = `calc(-100% - ${p.offsetX}px + ${p.overflowOffset || 0}px)`;
  } else {
    tX = `${p.offsetX}px`;
  }

  if (p.position === 'center') {
    tY = `calc(-50% + ${p.offsetY}px)`;
  } else {
    tY = `${p.offsetY}px`;
  }

  style.transform = `translateX(${tX}) translateY(${tY})`;

  return (
    <div
      className={p.className}
      style={{
        ...style,
        ...(p.style || {}),
      }}
      ref={p.innerRef}
    >
      {p.children}
    </div>
  );
}
